module.exports = __webpack_public_path__ + "img/linkedin2.2c20928d.svg";